import React from "react";
import { Card, CardContent } from "../ui/card";
import { UsersRound, CheckCircle2, Shield, Settings } from "lucide-react";

/**
 * UserStats — Tarjetas de estadísticas de la gestión de usuarios.
 *
 * Extraído 1:1 desde `pages/UsersPage.js`. Muestra 4 contadores derivados de la lista:
 * Total, Activos, Administradores (rol SUPERADMIN) y Técnicos (rol TECNICO).
 *
 * @param {Array} props.users Lista completa de usuarios del sistema.
 */
export const UserStats = ({ users }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card className="bg-[#0A0A35] border-[#1E1E5F]">
        <CardContent className="pt-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-lg bg-[#03BEE4]/20 flex items-center justify-center">
              <UsersRound className="h-6 w-6 text-[#03BEE4]" />
            </div>
            <div>
              <p className="text-slate-400 text-sm">Total Usuarios</p>
              <p className="text-2xl font-bold text-white">{users.length}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="bg-[#0A0A35] border-[#1E1E5F]">
        <CardContent className="pt-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-lg bg-[#42E695]/20 flex items-center justify-center">
              <CheckCircle2 className="h-6 w-6 text-[#42E695]" />
            </div>
            <div>
              <p className="text-slate-400 text-sm">Activos</p>
              <p className="text-2xl font-bold text-[#42E695]">
                {users.filter(u => u.is_active !== false).length}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="bg-[#0A0A35] border-[#1E1E5F]">
        <CardContent className="pt-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-lg bg-purple-500/20 flex items-center justify-center">
              <Shield className="h-6 w-6 text-purple-400" />
            </div>
            <div>
              <p className="text-slate-400 text-sm">Administradores</p>
              <p className="text-2xl font-bold text-purple-400">
                {users.filter(u => u.roles?.includes("SUPERADMIN")).length}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="bg-[#0A0A35] border-[#1E1E5F]">
        <CardContent className="pt-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-lg bg-orange-500/20 flex items-center justify-center">
              <Settings className="h-6 w-6 text-orange-400" />
            </div>
            <div>
              <p className="text-slate-400 text-sm">Técnicos</p>
              <p className="text-2xl font-bold text-orange-400">
                {users.filter(u => u.roles?.includes("TECNICO")).length}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
